/**
 * Cliente HTTP de las estadísticas del WhatsApp oficial (§B.6.2): mismo camino que `api.ts`
 * (`req()` de campana-nueva y `qs`), con el mismo criterio: nunca se manda `brandId` (el tenant
 * sale del token) y los ids van codificados.
 *
 * Archivo aparte de `api.ts` porque ese lo edita otro frente de trabajo: acá vive sólo lo que
 * cuelga de `/estadisticas`.
 */

import { req } from "../campana-nueva/api";
import { qs } from "./api";
import type { Resp } from "./api";
import type * as E from "./types.estadisticas";

const B = "/activa/oficial/estadisticas";
const e = (id: string) => encodeURIComponent(id);

/** Sólo `desde` y `hasta`: sin rango, el backend usa los últimos 30 días. */
const rq = (r?: Partial<E.RangoFechas>) => ({ desde: r?.desde, hasta: r?.hasta });

export const estadisticasApi = {
  marca: (rango?: Partial<E.RangoFechas>): Promise<Resp<E.EstadisticasMarca>> => req("GET", `${B}/marca${qs(rq(rango))}`),
  plantillas: (rango?: Partial<E.RangoFechas>, orden?: E.OrdenPlantillas): Promise<Resp<E.EstadisticasPlantillas>> =>
    req("GET", `${B}/plantillas${qs({ ...rq(rango), orden })}`),
  plantilla: (id: string, rango?: Partial<E.RangoFechas>): Promise<Resp<E.EstadisticasPlantilla>> => req("GET", `${B}/plantillas/${e(id)}${qs(rq(rango))}`),
  campana: (id: string): Promise<Resp<E.EstadisticasCampana>> => req("GET", `${B}/campanas/${e(id)}`),
  conversaciones: (rango?: Partial<E.RangoFechas>): Promise<Resp<E.EstadisticasConversaciones>> => req("GET", `${B}/conversaciones${qs(rq(rango))}`),
  twilio: (rango?: Partial<E.RangoFechas>): Promise<Resp<E.EstadisticasTwilio>> => req("GET", `${B}/twilio${qs(rq(rango))}`),
  /**
   * Sin tareas manda `{}` (el backend corre todas). `req()` omite un cuerpo falsy y algunos parsers
   * dan 400 con JSON vacío, por eso nunca `undefined`.
   */
  sincronizar: (tareas?: E.TareaSync[]): Promise<Resp<E.ResultadoSincronizacion>> =>
    req("POST", `${B}/twilio/sincronizar`, tareas?.length ? { tareas } : {}),
  alertas: (): Promise<Resp<E.AlertasTwilio>> => req("GET", `${B}/twilio/alertas`),
  guardarAlertas: (a: E.AlertasTwilioConfig): Promise<Resp<E.AlertasTwilio>> =>
    req("PUT", `${B}/twilio/alertas`, { gastoDiarioUSD: a.gastoDiarioUSD, gastoMensualUSD: a.gastoMensualUSD, saldoMinimoUSD: a.saldoMinimoUSD }),
  /** Sólo en simulado (en twilio el backend responde 409 SOLO_SIMULADO). Responde 204. */
  simularDisparo: (clave: E.ClaveTrigger): Promise<Resp<undefined>> => req("POST", `${B}/twilio/simular-disparo`, { clave }),
};
